import React, { useContext } from 'react'

import { useSelector } from 'react-redux'
import Flex from 'styled-flex-component'

import AnalyticsPostCampaignReportEmpty from '@components/Analytics/PostCampaignReport/ListView/Empty/Empty'
import AnalyticsPostCampaignReportListViewInsights from '@components/Analytics/PostCampaignReport/ListView/Insights/Insights'
import AnalyticsPostCampaignReportListViewAmount from '@components/Analytics/PostCampaignReport/ListView/Item/Amount'
import {
  Entry,
  RowWrapper,
} from '@components/Analytics/PostCampaignReport/ListView/ListView.styled'
import { CampaignContext } from '@context/Campaign'
import { IApplicationState } from '@store'
import {
  selectShowStoryPerformance,
  selectStoryCPM,
  selectStoryFollowers,
  selectStoryImpressions,
  selectStoryPublishedDate,
  selectStoryReach,
  selectStoryReachPct,
  selectStorySpend,
} from '@store/postCampaignReport'
import Theme from '@theme'
import { Container, Text } from '@tribegroup'
import { abbreviateNumber } from '@utils'

interface IProps {
  submissionId: number
  backgroundColor: string
}

const AnalyticsPostCampaignReportStoryListItem: React.FC<IProps> = ({
  submissionId,
  backgroundColor,
}) => {
  const {
    campaign: { is_price_hidden: isPriceHidden },
  } = useContext(CampaignContext)

  const publishedDate = useSelector((state: IApplicationState) =>
    selectStoryPublishedDate(state, submissionId),
  )
  const spend = useSelector((state: IApplicationState) => selectStorySpend(state, submissionId))
  const followers = useSelector((state: IApplicationState) =>
    selectStoryFollowers(state, submissionId),
  )
  const reach = useSelector((state: IApplicationState) => selectStoryReach(state, submissionId))
  const reachPct = useSelector((state: IApplicationState) =>
    selectStoryReachPct(state, submissionId),
  )
  const impressions = useSelector((state: IApplicationState) =>
    selectStoryImpressions(state, submissionId),
  )
  const cpm = useSelector((state: IApplicationState) => selectStoryCPM(state, submissionId))
  const showMetrics = useSelector((state: IApplicationState) =>
    selectShowStoryPerformance(state, submissionId),
  )

  if (!showMetrics) {
    return (
      <Container data-testid="story-purchase-empty">
        <AnalyticsPostCampaignReportEmpty
          minWidth={isPriceHidden ? 34.5 : 38.125}
          backgroundColor={backgroundColor}
        />
      </Container>
    )
  }

  return (
    <Container inline relative height={4.75}>
      <Flex>
        <RowWrapper data-testid="story-published-date" backgroundColor={backgroundColor}>
          <Entry>
            <Text color={Theme.grey900Color}>{publishedDate}</Text>
          </Entry>
        </RowWrapper>
        {!isPriceHidden && (
          <AnalyticsPostCampaignReportListViewAmount
            backgroundColor={backgroundColor}
            testId="story-purchase-amount"
            pattern="!###,### "
            value={spend}
          />
        )}
        <RowWrapper data-testid="story-followers" backgroundColor={backgroundColor}>
          <Entry>
            <Text color={Theme.grey900Color}>{abbreviateNumber(followers)}</Text>
          </Entry>
        </RowWrapper>
        <AnalyticsPostCampaignReportListViewInsights
          testIdPrefix="story"
          backgroundColor={backgroundColor}
          reach={reach}
          reachPct={reachPct}
          impressions={impressions}
          cpm={cpm}
          isPriceHidden={isPriceHidden}
        />
      </Flex>
    </Container>
  )
}

export default AnalyticsPostCampaignReportStoryListItem
